import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';

//imagenes
import logoWC from '../images/btWelcome.png';
import logoRezipe from '../images/logoExactoSignage.png';
import logoMenu from '../images/btMenumanager.png';

//librerias
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  
  
  
class MainMenu extends Component {
    
  constructor(props) {
    super(props);
    this.state = {isToggleOn: true};

    // This binding is necessary to make `this` work in the callback
    this.handleClickMenu = this.handleClickMenu.bind(this);    
    
  }
  

  
  handleClickMenu() {
    console.log("Menu Button");  
  }
  
  render() {
   
    const imgMenu = {                                
        width:'50px',
      };
    return (
        <div>
            <img src={logoMenu} style={imgMenu} onClick={this.handleClickMenu} />                        
        </div>
    );
  }
}

export default MainMenu;
